import { runWithRenderSlice } from "@otto-ec/global-resources/core";
import type { CustomElement } from "./utils";
import { setAriaLabel } from "../../global-event-handler/setAriaLabel.ts";

/**
 *
 *
 */
export type AutoAriaLabelElementProps = {
  /**
 *
 *
 *
 *
 */
  __ocAutoAriaLabel?: boolean;
};

/**
 *
 *
 *
 *
 *
 */
export const extendElementWithOcAutoAriaLabel = (Base: CustomElement): CustomElement =>
  class extends Base {
    async connectedCallback(): Promise<void> {
      await super.connectedCallback();

      runWithRenderSlice(() => {
        const actionElement = Array.from(this.children).find(
          (e): e is HTMLElement & AutoAriaLabelElementProps => e.slot === "",
        );

        if (actionElement?.ariaLabel === "oc-auto") actionElement.__ocAutoAriaLabel = true;
        if (actionElement?.__ocAutoAriaLabel) setAriaLabel(actionElement, this);
      });
    }
  };
